module.exports = __webpack_public_path__ + "img/PSAK-LOGO.486cf4f9.png";